import { FormattedMessage } from "react-intl";
import { Box } from "@material-ui/core";
import { useContext } from "react";

import { useStyles } from "./Language.style";
import {
  LanguageActionTypeEnum,
  LanguageContext,
  LanguageDispatchContext,
  LanguageState,
} from "../../context/LanguageContext";

export const supportedLanguages: Array<LanguageState> = [
  {
    message: "language.french",
    localeCode: "fr",
    remoteCode: "fr_FR",
  },
  {
    message: "language.english",
    localeCode: "en",
    remoteCode: "en_GB",
  },
];

const Language = (props: any) => {
  const classes = useStyles(props);
  // Context
  const languageState = useContext(LanguageContext);
  const languageDispatch = useContext(LanguageDispatchContext);

  const switchLanguage = (locale: LanguageState) => {
    languageDispatch({
      type: LanguageActionTypeEnum.switch,
      data: locale,
    });
  };

  return (
    <Box component="ul" className={classes.root}>
      {supportedLanguages.map((lang, index) => {
        return (
          <Box
            component="li"
            key={index}
            className={`${
              lang.localeCode === languageState.localeCode ? "current" : ""
            }`}
            onClick={(_) => switchLanguage(lang)}
          >
            <FormattedMessage id={lang.message} />
          </Box>
        );
      })}
    </Box>
  );
};

export default Language;
